import React, { useMemo, useCallback } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { highlightCodeInContent } from "~/components/TinyMCEDialogs/CodeHighLighter";
import { makeGetAllAttachmentsByParent } from "~/store/selectors/selector.attachments.jsx";
import { getCommentById } from "~/store/selectors/selector.comments.jsx";
import Angie from "~/utils/angie.jsx";
import { AttachmentList } from "../attachments/AttachmentList.jsx";
import { Description } from "../description/Description.jsx";
import { useFilePreviewContext, useFileTokenContext } from "../FilePreview/context/index.jsx";

export const CommentBody = ({ id }) => {
  const { openFilePreview } = useFilePreviewContext();
  const { preview_token, download_token, thumb_token } = useFileTokenContext();
  const getAllCommentAttachments = useMemo(
    () => makeGetAllAttachmentsByParent({ parentType: "Comment", parentId: id }),
    [id]
  );
  const comment = useSelector((state) => getCommentById(state, id));
  const allCommentAttachments = useSelector(getAllCommentAttachments);

  const attachments = useMemo(
    () => allCommentAttachments.filter((attachment) => attachment.disposition === "attachment"),
    [allCommentAttachments]
  );

  const body = useMemo(() => {
    const body = highlightCodeInContent(comment.body_formatted);

    return body
      .replace(/--PREVIEW-TOKEN--/g, preview_token)
      .replace(/--THUMBNAIL-TOKEN--/g, thumb_token)
      .replace(/--DOWNLOAD-TOKEN--/g, download_token);
  }, [comment.body_formatted, download_token, preview_token, thumb_token]);

  const downloadAllUrl = `${Angie.api_url}/attachments/comment/${id}/download`;

  const handleOpenPreview = useCallback(
    (id) => {
      openFilePreview(id, allCommentAttachments);
    },
    [allCommentAttachments, openFilePreview]
  );

  return (
    <div className="bubble_content tw-leading-6">
      <Description
        body={body}
        onImageClick={handleOpenPreview}
      />
      {attachments.length ? (
        <AttachmentList
          items={attachments}
          downloadAllUrl={downloadAllUrl}
          onItemClick={handleOpenPreview}
          hideTitle
        />
      ) : null}
    </div>
  );
};

CommentBody.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
